import { render, staticRenderFns } from "./NewDeposit.vue?vue&type=template&id=35e4bce0&"
import script from "./NewDeposit.vue?vue&type=script&lang=js&"
export * from "./NewDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports